

































import { Component, Vue } from 'vue-property-decorator';
import TitleMixin from '@/mixins/title-mixin';
import SecondaryNav from '@/components/navbars/secondary-nav.vue';
import EscalatedAlertTableTab from './components/escalated-alert-table-tab.vue';
import EscalatedAlertCard from './components/escalated-alert-card.vue';
import { EscalatedAlert } from '@/api';

@Component({
	components: {
		SecondaryNav,
		EscalatedAlertCard,
		EscalatedAlertTableTab,
	},
	mixins: [TitleMixin],
})
export default class EscalatedAlertList extends Vue {
	// Render fields - Used to control when child components re render
	public cardReRenderer: number = Math.random();
	public tableReRenderer: number = Math.random();

	public alert: EscalatedAlert | null = null;
	public idState: boolean = false;
	public tabIndex: number = 0;

	public pageTitle() {
		return 'Levno | Escalated Alerts';
	}

	public handleTabClick(newTabIndex: number) {
		this.tabIndex = newTabIndex;
		this.setAlert(null);
	}

	public setAlert(alert: EscalatedAlert | null) {
		this.alert = this.alert === alert ? null : alert;
		this.idState = this.alert !== null;
		this.cardReRenderer = -this.cardReRenderer;
	}

	public rerender() {
		this.tableReRenderer = -this.tableReRenderer;
		this.setAlert(null);
	}
}
